export default __webpack_public_path__ + "static/media/check.00d4bcd0.svg";